import AttendanceInProgress from './AttendanceInProgress';
import AttendanceInProgressNotification from './AttendanceInProgressNotification';
import Background from './Background';
import { BlurredInnerLayout, recordingAttendanceScreenClasses, Root } from './styles';
import useRecordingAttendanceScreen from './vm';

const RecordingAttendanceScreen = () => {
  useRecordingAttendanceScreen();

  return (
    <Root>
      <Background className={recordingAttendanceScreenClasses.background} />
      <BlurredInnerLayout>
        <AttendanceInProgress />
      </BlurredInnerLayout>
      <AttendanceInProgressNotification
        className={recordingAttendanceScreenClasses.attendanceInProgressNotification}
      />
    </Root>
  );
};

export default RecordingAttendanceScreen;
